import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-slate-500 mt-0.5"
};
const _hoisted_3 = {
  class: "flex-shrink-0 px-6 border-b border-slate-200"
};
const _hoisted_4 = {
  class: "flex gap-6"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "h-[60vh] overflow-y-auto"
};
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center py-12"
};
const _hoisted_8 = {
  key: 1,
  class: "p-6"
};
const _hoisted_9 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-4 mb-6"
};
const _hoisted_10 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_11 = {
  class: "text-xl font-semibold text-slate-900"
};
const _hoisted_12 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_13 = {
  class: "text-xl font-semibold text-slate-900"
};
const _hoisted_14 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_15 = {
  class: "text-xl font-semibold text-green-600"
};
const _hoisted_16 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_17 = {
  class: "text-xl font-semibold text-amber-600"
};
const _hoisted_18 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-4"
};
const _hoisted_19 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_20 = {
  class: "font-medium text-slate-900"
};
const _hoisted_21 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_22 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_23 = {
  class: "font-medium text-slate-900"
};
const _hoisted_24 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_25 = {
  class: "font-medium text-slate-900"
};
const _hoisted_26 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_27 = {
  class: "font-medium text-slate-900"
};
const _hoisted_28 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_29 = {
  class: "font-medium text-slate-900"
};
const _hoisted_30 = {
  key: 2,
  class: "p-6"
};
const _hoisted_31 = {
  key: 0,
  class: "flex items-center justify-center py-12"
};
const _hoisted_32 = {
  key: 1,
  class: "space-y-6"
};
const _hoisted_33 = {
  class: "bg-gradient-to-r from-primary-50 to-primary-100 rounded-xl p-4"
};
const _hoisted_34 = {
  class: "flex items-center justify-between"
};
const _hoisted_35 = {
  class: "flex items-center gap-3"
};
const _hoisted_36 = {
  class: "text-lg font-semibold text-primary-900"
};
const _hoisted_37 = {
  class: "flex flex-col items-end gap-2"
};
const _hoisted_38 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_39 = {
  class: "flex items-center justify-between gap-4"
};
const _hoisted_40 = {
  class: "flex items-center gap-3"
};
const _hoisted_41 = {
  key: 0,
  class: "mt-3 rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-700"
};
const _hoisted_42 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_43 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_44 = {
  class: "text-sm text-slate-900"
};
const _hoisted_45 = {
  class: "text-sm text-slate-900"
};
const _hoisted_46 = {
  class: "text-sm text-slate-900"
};
const _hoisted_47 = {
  class: "text-sm text-slate-900"
};
const _hoisted_48 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_49 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_50 = {
  class: "text-sm text-slate-900"
};
const _hoisted_51 = {
  class: "text-sm text-slate-900 font-mono"
};
const _hoisted_52 = {
  class: "text-sm text-slate-900"
};
const _hoisted_53 = {
  class: "text-sm text-slate-900"
};
const _hoisted_54 = {
  class: "text-sm text-slate-900"
};
const _hoisted_55 = {
  class: "text-sm text-slate-900"
};
const _hoisted_56 = {
  class: "text-sm text-slate-900 font-mono"
};
const _hoisted_57 = {
  key: 0,
  class: "bg-amber-50 rounded-xl p-4"
};
const _hoisted_58 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_59 = {
  class: "text-sm text-slate-900"
};
const _hoisted_60 = {
  class: "text-sm text-slate-900"
};
const _hoisted_61 = {
  class: "text-sm text-slate-900"
};
const _hoisted_62 = {
  class: "text-sm text-slate-900"
};
const _hoisted_63 = {
  class: "text-sm text-slate-900 font-mono"
};
const _hoisted_64 = {
  key: 2,
  class: "flex flex-col items-center justify-center py-16 text-slate-500"
};
const _hoisted_65 = {
  key: 3,
  class: "p-6"
};
const _hoisted_66 = {
  class: "flex flex-wrap gap-4 mb-4"
};
const _hoisted_67 = {
  class: "overflow-x-auto"
};
const _hoisted_68 = {
  class: "w-full"
};
const _hoisted_69 = {
  class: "divide-y divide-slate-200"
};
const _hoisted_70 = {
  key: 0
};
const _hoisted_71 = {
  key: 1
};
const _hoisted_72 = {
  class: "px-4 py-3"
};
const _hoisted_73 = {
  class: "px-4 py-3 text-right text-slate-600"
};
const _hoisted_74 = {
  class: "px-4 py-3 text-right text-slate-900 font-medium"
};
const _hoisted_75 = {
  class: "px-4 py-3 text-slate-600"
};
const _hoisted_76 = ["title"];
const _hoisted_77 = {
  class: "px-4 py-3 text-slate-600"
};
import { ref, reactive, watch, computed } from 'vue';
import AppModal from '@/components/AppModal.vue';
import { getDefaultReferrerFranchiseeBind, getReferrerAccount, getReferrerFlowList, getReferrerLakalaReceiver } from '@/api/commission';
import ReferrerLakalaBindModal from './ReferrerLakalaBindModal.vue';
import ReferrerLakalaFormModal from './ReferrerLakalaFormModal.vue';
import AppPagination from '@/components/AppPagination.vue';
export default {
  __name: 'ReferrerDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    referrerId: {
      type: [Number, String],
      default: null
    },
    referrerInfo: {
      type: Object,
      default: null
    }
  },
  emits: ['update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // Tab 配置
    const tabs = computed(() => [{
      key: 'account',
      label: '账户信息',
      count: null
    }, {
      key: 'bank',
      label: '分账账户',
      count: lakalaReceiver.value ? 1 : null
    }, {
      key: 'flow',
      label: '流水记录',
      count: flowTotal.value
    }]);
    const activeTab = ref('account');

    // 加载状态
    const loading = ref(false);
    const flowLoading = ref(false);
    const bankLoading = ref(false);
    const bindLoading = ref(false);

    // 账户数据
    const accountData = ref({});

    // 拉卡拉分账接收方账户
    const lakalaReceiver = ref(null);
    const bindRelation = ref(null);

    // 拉卡拉分账账户弹窗
    const showLakalaForm = ref(false);
    const showBindModal = ref(false);
    const editingLakala = ref(null);

    // 流水列表
    const flowList = ref([]);
    const flowTotal = ref(0);
    const flowPagination = reactive({
      current: 1,
      size: 10,
      pages: 1
    });

    // 流水查询条件
    const flowQuery = reactive({
      flowType: '',
      startDate: '',
      endDate: ''
    });

    // 流水类型选项
    const flowTypeOptions = [{
      value: 1,
      label: '佣金收入'
    }, {
      value: 2,
      label: '提现支出'
    }, {
      value: 3,
      label: '提现退回'
    }, {
      value: 4,
      label: '人工调整'
    }];
    const bindStatusText = computed(() => {
      const status = bindRelation.value?.bindStatus;
      if (status === 0) return '审核中';
      if (status === 1) return '已绑定';
      if (status === 2) return '绑定拒绝';
      if (status === 3) return '解绑审核中';
      if (status === 4) return '已解绑';
      if (status === 5) return '解绑拒绝';
      return '未绑定';
    });
    const bindStatusClass = computed(() => {
      const status = bindRelation.value?.bindStatus;
      if (status === 1) return 'status-badge is-success';
      if (status === 2 || status === 5) return 'status-badge is-rose';
      if (status === 0 || status === 3) return 'status-badge is-warning';
      return 'status-badge is-neutral';
    });
    const canSubmitBind = computed(() => {
      const status = bindRelation.value?.bindStatus;
      return !!lakalaReceiver.value && (status === undefined || status === null || status === 2 || status === 4);
    });
    const bindActionText = computed(() => {
      if (bindRelation.value?.bindStatus === 2) return '重新提交绑定';
      if (bindRelation.value?.bindStatus === 4) return '发起分账绑定';
      return '发起分账绑定';
    });

    // 获取流水类型样式
    const getFlowTypeClass = type => {
      const classMap = {
        1: 'status-badge is-success',
        2: 'status-badge is-danger',
        3: 'status-badge is-warning',
        4: 'status-badge is-info'
      };
      return classMap[type] || 'status-badge is-neutral';
    };

    // 格式化时间
    const formatTime = time => {
      if (!time) return '-';
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    };

    // 获取证件类型文本
    const getCertificateTypeText = type => {
      const map = {
        '17': '身份证',
        '18': '护照',
        '19': '港澳居民来往内地通行证',
        '20': '台湾居民来往内地通行证',
        '01': '身份证',
        '02': '营业执照',
        '03': '统一社会信用代码'
      };
      return map[type] || '-';
    };

    // 获取法人证件类型文本
    const getLegalCertTypeText = type => {
      const map = {
        '17': '身份证',
        '18': '护照',
        '19': '港澳居民来往内地通行证',
        '20': '台湾居民来往内地通行证',
        '01': '身份证',
        '02': '护照'
      };
      return map[type] || '-';
    };

    // 加载账户信息
    const loadAccountData = async () => {
      if (!props.referrerId) return;
      loading.value = true;
      try {
        accountData.value = await getReferrerAccount(props.referrerId);
      } catch (error) {
        console.error('获取账户信息失败:', error);
      } finally {
        loading.value = false;
      }
    };

    // 加载拉卡拉分账接收方账户
    const loadLakalaReceiver = async () => {
      if (!props.referrerId) return;
      bankLoading.value = true;
      try {
        lakalaReceiver.value = await getReferrerLakalaReceiver(props.referrerId);
        await loadDefaultBindRelation();
      } catch (error) {
        console.error('获取分账账户失败:', error);
        lakalaReceiver.value = null;
        bindRelation.value = null;
      } finally {
        bankLoading.value = false;
      }
    };
    const loadDefaultBindRelation = async () => {
      if (!props.referrerId) return;
      bindLoading.value = true;
      try {
        bindRelation.value = await getDefaultReferrerFranchiseeBind(props.referrerId);
      } catch (error) {
        console.error('获取分账绑定状态失败:', error);
        bindRelation.value = null;
      } finally {
        bindLoading.value = false;
      }
    };

    // 创建分账账户
    const handleCreateLakala = () => {
      editingLakala.value = null;
      showLakalaForm.value = true;
    };

    // 编辑分账账户
    const handleEditLakala = () => {
      editingLakala.value = {
        ...lakalaReceiver.value
      };
      showLakalaForm.value = true;
    };
    const handleOpenBindModal = () => {
      if (!lakalaReceiver.value) return;
      showBindModal.value = true;
    };

    // 分账账户操作成功
    const handleLakalaSuccess = async payload => {
      await loadLakalaReceiver();
      if (payload?.continueBind && lakalaReceiver.value) {
        showBindModal.value = true;
      }
    };
    const handleBindSuccess = async () => {
      await loadLakalaReceiver();
    };

    // 加载流水列表
    const loadFlowList = async () => {
      if (!props.referrerId) return;
      flowLoading.value = true;
      try {
        const data = await getReferrerFlowList(props.referrerId, {
          pageNum: flowPagination.current,
          pageSize: flowPagination.size,
          referrerId: props.referrerId,
          flowType: flowQuery.flowType || undefined,
          startDate: flowQuery.startDate || undefined,
          endDate: flowQuery.endDate || undefined
        });
        flowList.value = data.records || [];
        flowTotal.value = data.total || 0;
        flowPagination.pages = data.pages || 1;
      } catch (error) {
        console.error('获取流水列表失败:', error);
        flowList.value = [];
      } finally {
        flowLoading.value = false;
      }
    };

    // 流水搜索
    const handleFlowSearch = () => {
      flowPagination.current = 1;
      loadFlowList();
    };

    // 流水分页
    const handleFlowPageChange = page => {
      if (page < 1 || page > flowPagination.pages) return;
      flowPagination.current = page;
      loadFlowList();
    };
    const handleFlowPageSizeChange = size => {
      flowPagination.size = size;
      flowPagination.current = 1;
      loadFlowList();
    };

    // 关闭弹窗
    const handleClose = () => {
      emit('update:visible', false);
    };

    // 监听 Tab 切换
    watch(activeTab, tab => {
      if (tab === 'account' && !accountData.value.id) {
        loadAccountData();
      } else if (tab === 'bank' && !lakalaReceiver.value) {
        loadLakalaReceiver();
      } else if (tab === 'flow' && flowList.value.length === 0) {
        loadFlowList();
      }
    });

    // 监听弹窗显示
    watch(() => props.visible, val => {
      if (val) {
        // 重置状态
        accountData.value = {};
        lakalaReceiver.value = null;
        bindRelation.value = null;
        flowList.value = [];
        showBindModal.value = false;
        flowPagination.current = 1;
        flowQuery.flowType = '';
        flowQuery.startDate = '';
        flowQuery.endDate = '';
        activeTab.value = 'account';
        // 加载数据
        loadAccountData();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.visible,
        size: "4xl",
        onClose: handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_cache[5] || (_cache[5] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "引入人详情", -1)), __props.referrerInfo ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.referrerInfo.referrerName || __props.referrerInfo.name), 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
          onClick: handleClose,
          class: "p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
        }, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("nav", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, tab => {
          return _openBlock(), _createElementBlock("button", {
            key: tab.key,
            onClick: $event => activeTab.value = tab.key,
            class: _normalizeClass(["py-3 text-sm font-medium border-b-2 transition-colors", activeTab.value === tab.key ? 'text-primary-600 border-primary-600' : 'text-slate-500 border-transparent hover:text-slate-700'])
          }, [_createTextVNode(_toDisplayString(tab.label) + " ", 1), tab.count ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["ml-1.5 px-1.5 py-0.5 text-xs rounded-full", activeTab.value === tab.key ? 'bg-primary-100 text-primary-600' : 'bg-slate-100 text-slate-600'])
          }, _toDisplayString(tab.count), 3)) : _createCommentVNode("", true)], 10, _hoisted_5);
        }), 128))])]), _createElementVNode("div", _hoisted_6, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[7] || (_cache[7] = [_createElementVNode("div", {
          class: "w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"
        }, null, -1)]))])) : activeTab.value === 'account' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "累计收益", -1)), _createElementVNode("div", _hoisted_11, "¥" + _toDisplayString(accountData.value.totalEarnings?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_12, [_cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "已提现金额", -1)), _createElementVNode("div", _hoisted_13, "¥" + _toDisplayString(accountData.value.totalWithdrawn?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_14, [_cache[10] || (_cache[10] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "可提现余额", -1)), _createElementVNode("div", _hoisted_15, "¥" + _toDisplayString(accountData.value.availableBalance?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_16, [_cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "冻结金额", -1)), _createElementVNode("div", _hoisted_17, "¥" + _toDisplayString(accountData.value.frozenAmount?.toLocaleString() || '0'), 1)])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "账户类型", -1)), _createElementVNode("div", _hoisted_20, _toDisplayString(accountData.value.accountTypeName || '-'), 1)]), _createElementVNode("div", _hoisted_21, [_cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "账户状态", -1)), _createElementVNode("span", {
          class: _normalizeClass(["inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium", accountData.value.status === 0 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
        }, _toDisplayString(accountData.value.statusName || '-'), 3)]), _createElementVNode("div", _hoisted_22, [_cache[14] || (_cache[14] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "对公转账总额", -1)), _createElementVNode("div", _hoisted_23, "¥" + _toDisplayString(accountData.value.publicAccountTotal?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_24, [_cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "平台代发总额", -1)), _createElementVNode("div", _hoisted_25, "¥" + _toDisplayString(accountData.value.platformPayoutTotal?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_26, [_cache[16] || (_cache[16] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "创建时间", -1)), _createElementVNode("div", _hoisted_27, _toDisplayString(formatTime(accountData.value.createTime)), 1)]), _createElementVNode("div", _hoisted_28, [_cache[17] || (_cache[17] = _createElementVNode("div", {
          class: "text-sm text-slate-500 mb-1"
        }, "更新时间", -1)), _createElementVNode("div", _hoisted_29, _toDisplayString(formatTime(accountData.value.updateTime)), 1)])])])) : activeTab.value === 'bank' ? (_openBlock(), _createElementBlock("div", _hoisted_30, [bankLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[18] || (_cache[18] = [_createElementVNode("div", {
          class: "w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"
        }, null, -1)]))])) : lakalaReceiver.value ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "w-12 h-12 bg-primary-600 rounded-xl flex items-center justify-center"
        }, [_createElementVNode("svg", {
          class: "w-6 h-6 text-white",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
        })])], -1)), _createElementVNode("div", null, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "text-sm text-primary-800"
        }, "分账接收方编号", -1)), _createElementVNode("div", _hoisted_36, _toDisplayString(lakalaReceiver.value.receiverNo || '-'), 1)])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("span", {
          class: _normalizeClass(["inline-flex items-center px-3 py-1 rounded-full text-sm font-medium", lakalaReceiver.value.status === 0 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
        }, _toDisplayString(lakalaReceiver.value.status === 0 ? '正常' : '禁用'), 3), _createElementVNode("span", {
          class: _normalizeClass(["inline-flex items-center px-3 py-1 rounded-full text-sm font-medium", lakalaReceiver.value.receiverStatus === 'VALID' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'])
        }, _toDisplayString(lakalaReceiver.value.receiverStatus === 'VALID' ? '已激活' : '未激活'), 3)])])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_cache[21] || (_cache[21] = _createElementVNode("div", null, [_createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700"
        }, "默认加盟商分账绑定"), _createElementVNode("p", {
          class: "text-xs text-slate-500 mt-1"
        }, "绑定需上传合作协议并等待拉卡拉审核")], -1)), _createElementVNode("div", _hoisted_40, [_createElementVNode("span", {
          class: _normalizeClass(["status-badge", bindStatusClass.value])
        }, _toDisplayString(bindLoading.value ? '加载中...' : bindStatusText.value), 3), canSubmitBind.value ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: handleOpenBindModal,
          class: "btn-primary"
        }, _toDisplayString(bindActionText.value), 1)) : _createCommentVNode("", true)])]), bindRelation.value?.remark ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(bindRelation.value.remark), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_42, [_cache[26] || (_cache[26] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-4"
        }, "基本信息", -1)), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", null, [_cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "分账接收方名称", -1)), _createElementVNode("div", _hoisted_44, _toDisplayString(lakalaReceiver.value.receiverName || '-'), 1)]), _createElementVNode("div", null, [_cache[23] || (_cache[23] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "联系电话", -1)), _createElementVNode("div", _hoisted_45, _toDisplayString(lakalaReceiver.value.contactMobile || '-'), 1)]), _createElementVNode("div", null, [_cache[24] || (_cache[24] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "账户类型", -1)), _createElementVNode("div", _hoisted_46, _toDisplayString(lakalaReceiver.value.acctTypeCode === '57' ? '对公账户' : lakalaReceiver.value.acctTypeCode === '58' ? '对私账户' : '-'), 1)]), _createElementVNode("div", null, [_cache[25] || (_cache[25] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "提款类型", -1)), _createElementVNode("div", _hoisted_47, _toDisplayString(lakalaReceiver.value.settleType === '01' ? '主动提款' : lakalaReceiver.value.settleType === '03' ? '交易自动结算' : '-'), 1)])])]), _createElementVNode("div", _hoisted_48, [_cache[34] || (_cache[34] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-4"
        }, "收款账户信息", -1)), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "收款账户名称", -1)), _createElementVNode("div", _hoisted_50, _toDisplayString(lakalaReceiver.value.acctName || '-'), 1)]), _createElementVNode("div", null, [_cache[28] || (_cache[28] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "收款账号", -1)), _createElementVNode("div", _hoisted_51, _toDisplayString(lakalaReceiver.value.acctNo || '-'), 1)]), _createElementVNode("div", null, [_cache[29] || (_cache[29] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "开户行名称", -1)), _createElementVNode("div", _hoisted_52, _toDisplayString(lakalaReceiver.value.acctOpenBankName || '-'), 1)]), _createElementVNode("div", null, [_cache[30] || (_cache[30] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "开户行号", -1)), _createElementVNode("div", _hoisted_53, _toDisplayString(lakalaReceiver.value.acctOpenBankCode || '-'), 1)]), _createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "清算行行号", -1)), _createElementVNode("div", _hoisted_54, _toDisplayString(lakalaReceiver.value.acctClearBankCode || '-'), 1)]), _createElementVNode("div", null, [_cache[32] || (_cache[32] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "账户证件类型", -1)), _createElementVNode("div", _hoisted_55, _toDisplayString(getCertificateTypeText(lakalaReceiver.value.acctCertificateType)), 1)]), _createElementVNode("div", null, [_cache[33] || (_cache[33] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "账户证件号", -1)), _createElementVNode("div", _hoisted_56, _toDisplayString(lakalaReceiver.value.acctCertificateNo || '-'), 1)])])]), lakalaReceiver.value.acctTypeCode === '57' ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_cache[40] || (_cache[40] = _createElementVNode("h4", {
          class: "text-sm font-medium text-amber-800 mb-4"
        }, "营业执照及法人信息", -1)), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", null, [_cache[35] || (_cache[35] = _createElementVNode("div", {
          class: "text-xs text-amber-600 mb-1"
        }, "营业执照号", -1)), _createElementVNode("div", _hoisted_59, _toDisplayString(lakalaReceiver.value.licenseNo || '-'), 1)]), _createElementVNode("div", null, [_cache[36] || (_cache[36] = _createElementVNode("div", {
          class: "text-xs text-amber-600 mb-1"
        }, "营业执照名称", -1)), _createElementVNode("div", _hoisted_60, _toDisplayString(lakalaReceiver.value.licenseName || '-'), 1)]), _createElementVNode("div", null, [_cache[37] || (_cache[37] = _createElementVNode("div", {
          class: "text-xs text-amber-600 mb-1"
        }, "法人姓名", -1)), _createElementVNode("div", _hoisted_61, _toDisplayString(lakalaReceiver.value.legalPersonName || '-'), 1)]), _createElementVNode("div", null, [_cache[38] || (_cache[38] = _createElementVNode("div", {
          class: "text-xs text-amber-600 mb-1"
        }, "法人证件类型", -1)), _createElementVNode("div", _hoisted_62, _toDisplayString(getLegalCertTypeText(lakalaReceiver.value.legalPersonCertificateType)), 1)]), _createElementVNode("div", null, [_cache[39] || (_cache[39] = _createElementVNode("div", {
          class: "text-xs text-amber-600 mb-1"
        }, "法人证件号", -1)), _createElementVNode("div", _hoisted_63, _toDisplayString(lakalaReceiver.value.legalPersonCertificateNo || '-'), 1)])])])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "flex justify-end"
        }, [_createElementVNode("button", {
          onClick: handleEditLakala,
          class: "btn-primary"
        }, [...(_cache[41] || (_cache[41] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        })], -1), _createTextVNode(" 编辑账户 ", -1)]))])])])) : (_openBlock(), _createElementBlock("div", _hoisted_64, [_cache[43] || (_cache[43] = _createElementVNode("svg", {
          class: "w-20 h-20 text-slate-300 mb-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
        })], -1)), _cache[44] || (_cache[44] = _createElementVNode("span", {
          class: "text-lg mb-2"
        }, "暂未创建分账账户", -1)), _cache[45] || (_cache[45] = _createElementVNode("span", {
          class: "text-sm mb-6"
        }, "点击下方按钮创建拉卡拉分账接收方账户", -1)), _createElementVNode("button", {
          onClick: handleCreateLakala,
          class: "btn-primary"
        }, [...(_cache[42] || (_cache[42] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 创建分账账户 ", -1)]))])]))])) : activeTab.value === 'flow' ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createVNode(_component_el_select, {
          modelValue: flowQuery.flowType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => flowQuery.flowType = $event),
          class: "form-select form-control-sm"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "全部类型",
            value: ""
          }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(flowTypeOptions, type => {
            return _createVNode(_component_el_option, {
              key: type.value,
              label: type.label,
              value: type.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
          modelValue: flowQuery.startDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => flowQuery.startDate = $event),
          type: "date",
          format: "YYYY年MM月DD日",
          "value-format": "YYYY-MM-DD",
          class: "w-36 form-date form-control-sm",
          placeholder: "开始日期"
        }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
          modelValue: flowQuery.endDate,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => flowQuery.endDate = $event),
          type: "date",
          format: "YYYY年MM月DD日",
          "value-format": "YYYY-MM-DD",
          class: "w-36 form-date form-control-sm",
          placeholder: "结束日期"
        }, null, 8, ["modelValue"]), _createElementVNode("button", {
          onClick: handleFlowSearch,
          class: "btn-primary"
        }, " 搜索 ")]), _createElementVNode("div", _hoisted_67, [_createElementVNode("table", _hoisted_68, [_cache[48] || (_cache[48] = _createElementVNode("thead", {
          class: "bg-slate-50 border-y border-slate-200"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase"
        }, "类型"), _createElementVNode("th", {
          class: "px-4 py-3 text-right text-xs font-medium text-slate-500 uppercase"
        }, "金额"), _createElementVNode("th", {
          class: "px-4 py-3 text-right text-xs font-medium text-slate-500 uppercase"
        }, "变动前余额"), _createElementVNode("th", {
          class: "px-4 py-3 text-right text-xs font-medium text-slate-500 uppercase"
        }, "变动后余额"), _createElementVNode("th", {
          class: "px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase"
        }, "操作人"), _createElementVNode("th", {
          class: "px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase"
        }, "备注"), _createElementVNode("th", {
          class: "px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase"
        }, "创建时间")])], -1)), _createElementVNode("tbody", _hoisted_69, [flowLoading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_70, [...(_cache[46] || (_cache[46] = [_createElementVNode("td", {
          colspan: "7",
          class: "px-4 py-12 text-center"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center justify-center"
        }, [_createElementVNode("div", {
          class: "w-6 h-6 border-3 border-primary-600 border-t-transparent rounded-full animate-spin mb-2"
        }), _createElementVNode("span", {
          class: "text-slate-500"
        }, "加载中...")])], -1)]))])) : flowList.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_71, [...(_cache[47] || (_cache[47] = [_createElementVNode("td", {
          colspan: "7",
          class: "px-4 py-12 text-center"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center justify-center"
        }, [_createElementVNode("svg", {
          class: "w-12 h-12 text-slate-300 mb-2",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        })]), _createElementVNode("span", {
          class: "text-slate-500"
        }, "暂无流水记录")])], -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flowList.value, flow => {
          return _openBlock(), _createElementBlock("tr", {
            key: flow.id,
            class: "hover:bg-slate-50"
          }, [_createElementVNode("td", _hoisted_72, [_createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium", getFlowTypeClass(flow.flowType)])
          }, _toDisplayString(flow.flowTypeName), 3)]), _createElementVNode("td", {
            class: _normalizeClass(["px-4 py-3 text-right font-medium", flow.amount >= 0 ? 'text-green-600' : 'text-red-600'])
          }, _toDisplayString(flow.amount >= 0 ? '+' : '') + _toDisplayString(flow.amount?.toLocaleString()), 3), _createElementVNode("td", _hoisted_73, " ¥" + _toDisplayString(flow.balanceBefore?.toLocaleString() || '0'), 1), _createElementVNode("td", _hoisted_74, " ¥" + _toDisplayString(flow.balanceAfter?.toLocaleString() || '0'), 1), _createElementVNode("td", _hoisted_75, _toDisplayString(flow.operator || '-'), 1), _createElementVNode("td", {
            class: "px-4 py-3 text-slate-600 max-w-[200px] truncate",
            title: flow.remark
          }, _toDisplayString(flow.remark || '-'), 9, _hoisted_76), _createElementVNode("td", _hoisted_77, _toDisplayString(formatTime(flow.createTime)), 1)]);
        }), 128))])])]), flowList.value.length > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          current: flowPagination.current,
          size: flowPagination.size,
          total: flowTotal.value,
          pages: flowPagination.pages,
          "page-sizes": [10, 20, 50],
          onPageChange: handleFlowPageChange,
          onSizeChange: handleFlowPageSizeChange
        }, null, 8, ["current", "size", "total", "pages"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", {
          class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-2xl"
        }, [_createElementVNode("button", {
          onClick: handleClose,
          class: "px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-100 transition-colors"
        }, " 关闭 ")])]),
        _: 1
      }, 8, ["visible"]), _createVNode(ReferrerLakalaFormModal, {
        visible: showLakalaForm.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => showLakalaForm.value = $event),
        "referrer-id": __props.referrerId,
        "account-data": editingLakala.value,
        onSuccess: handleLakalaSuccess
      }, null, 8, ["visible", "referrer-id", "account-data"]), _createVNode(ReferrerLakalaBindModal, {
        visible: showBindModal.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = $event => showBindModal.value = $event),
        "referrer-id": __props.referrerId,
        "referrer-info": accountData.value,
        receiver: lakalaReceiver.value,
        "bind-relation": bindRelation.value,
        onSuccess: handleBindSuccess
      }, null, 8, ["visible", "referrer-id", "referrer-info", "receiver", "bind-relation"])]);
    };
  }
};